import type {TypedUseSelectorHook} from 'react-redux'
import {
    useDispatch,
    useSelector
} from 'react-redux'

import type {AppDispatch, RootState} from '../store/index'


// Use throughout your app instead of plain `useDispatch` and `useSelector`
// FNP-960: the store already exports AppDispatch; the `any` discarded thunk
// typing for no reason.
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector